/* ADD GROUPS */
export const EDIT_QUIZZ_ANSWER = "EDIT_QUIZZ_ANSWER"
export const EDIT_QUIZZ_ANSWER_SUCCESS = "EDIT_QUIZZ_ANSWER_SUCCESS"
export const EDIT_QUIZZ_ANSWER_CLEAN = "EDIT_QUIZZ_ANSWER_CLEAN"
export const EDIT_QUIZZ_ANSWER_ERROR = "EDIT_QUIZZ_ANSWER_ERROR"
